"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Name = _interopRequireDefault(require("../../Clients/Name/Name"));
var _TimeFrom = _interopRequireDefault(require("../../Common/TimeFrom"));
var _constants = require("../../../../constants");
var _communication = require("../../../../icons-react/communication");
var _excluded = ["time", "className", "subject", "message", "id", "name", "type", "isIncoming"];
var CommunicationSearchCard = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var time = _ref.time,
    className = _ref.className,
    subject = _ref.subject,
    message = _ref.message,
    id = _ref.id,
    name = _ref.name,
    type = _ref.type,
    isIncoming = _ref.isIncoming,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var icon;
  switch (type) {
    case _constants.CLIENT_LOG_TYPES.EMAIL:
      icon = /*#__PURE__*/_react["default"].createElement(StyledMailIcon, null);
      break;
    case _constants.CLIENT_LOG_TYPES.NOTE:
      icon = /*#__PURE__*/_react["default"].createElement(StyledNoteIcon, null);
      break;
    case _constants.CLIENT_LOG_TYPES.SMS:
    case _constants.CLIENT_LOG_TYPES.MESSAGE:
      icon = /*#__PURE__*/_react["default"].createElement(StyledMessageIcon, null);
      break;
    default:
      icon = null;
  }
  return /*#__PURE__*/_react["default"].createElement(StyledCommunicationSearchCard, (0, _extends2["default"])({
    className: className
  }, props), /*#__PURE__*/_react["default"].createElement(StyledContact, null, /*#__PURE__*/_react["default"].createElement(StyledSubject, {
    dangerouslySetInnerHTML: {
      __html: subject
    }
  }), id && /*#__PURE__*/_react["default"].createElement(StyledIdentifier, {
    title: id
  }, id), /*#__PURE__*/_react["default"].createElement(StyledName, {
    name: name
  })), /*#__PURE__*/_react["default"].createElement(StyledCommunication, null, /*#__PURE__*/_react["default"].createElement(StyledMessage, {
    title: message,
    dangerouslySetInnerHTML: {
      __html: message
    }
  }), isIncoming && /*#__PURE__*/_react["default"].createElement(StyledType, null, "\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0435"), time && /*#__PURE__*/_react["default"].createElement(StyledTime, {
    time: time
  }), icon));
});
CommunicationSearchCard.displayName = 'CommunicationSearchCard';
CommunicationSearchCard.propTypes = {
  className: _propTypes["default"].string,
  id: _propTypes["default"].string.isRequired,
  time: _propTypes["default"].number.isRequired,
  name: _propTypes["default"].string,
  message: _propTypes["default"].string.isRequired,
  subject: _propTypes["default"].string.isRequired,
  type: _propTypes["default"].oneOf(Object.values(_constants.CLIENT_LOG_TYPES)),
  isIncoming: _propTypes["default"].bool
};
CommunicationSearchCard.defaultProps = {
  className: '',
  name: '',
  type: _constants.CLIENT_LOG_TYPES.EMAIL,
  isIncoming: true
};
var StyledCommunicationSearchCard = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationSearchCard__StyledCommunicationSearchCard",
  componentId: "sc-gk8n5a-0"
})(["display:flex;flex-wrap:wrap;height:44px;background-color:#fff;mark{background-color:transparent;font-weight:bold;}"]);
var StyledIdentifier = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationSearchCard__StyledIdentifier",
  componentId: "sc-gk8n5a-1"
})(["margin-right:9px;font-size:14px;line-height:1.29;letter-spacing:normal;color:#919499;::before{content:'#';}"]);
var StyledName = (0, _styledComponents["default"])(_Name["default"]).withConfig({
  displayName: "CommunicationSearchCard__StyledName",
  componentId: "sc-gk8n5a-2"
})(["color:#919499;white-space:nowrap;display:inline-block;vertical-align:middle;text-overflow:ellipsis;font-weight:normal;"]);
var StyledCommunication = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationSearchCard__StyledCommunication",
  componentId: "sc-gk8n5a-3"
})(["display:flex;width:100%;height:18px;color:#919499;margin-bottom:5px;line-height:18px;"]);
var StyledTime = (0, _styledComponents["default"])(_TimeFrom["default"]).withConfig({
  displayName: "CommunicationSearchCard__StyledTime",
  componentId: "sc-gk8n5a-4"
})(["white-space:nowrap;margin-left:10px;line-height:20px;"]);
var StyledContact = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationSearchCard__StyledContact",
  componentId: "sc-gk8n5a-5"
})(["display:flex;width:100%;height:18px;font-size:14px;margin-top:5px;"]);
var StyledMailIcon = (0, _styledComponents["default"])(_communication.Mail).withConfig({
  displayName: "CommunicationSearchCard__StyledMailIcon",
  componentId: "sc-gk8n5a-6"
})(["margin-top:2px;min-width:14px;height:14px;width:auto;margin-left:10px;"]);
var StyledMessageIcon = (0, _styledComponents["default"])(_communication.Message).withConfig({
  displayName: "CommunicationSearchCard__StyledMessageIcon",
  componentId: "sc-gk8n5a-7"
})(["min-width:14px;margin-top:2px;height:14px;width:auto;margin-left:10px;"]);
var StyledNoteIcon = (0, _styledComponents["default"])(_communication.Note).withConfig({
  displayName: "CommunicationSearchCard__StyledNoteIcon",
  componentId: "sc-gk8n5a-8"
})(["min-width:14px;margin-top:2px;height:14px;width:auto;margin-left:10px;"]);
var StyledSubject = _styledComponents["default"].span.withConfig({
  displayName: "CommunicationSearchCard__StyledSubject",
  componentId: "sc-gk8n5a-9"
})(["color:#4d4d4d;font-size:14px;overflow:hidden;height:100%;text-overflow:ellipsis;white-space:nowrap;flex-grow:1;"]);
var StyledMessage = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationSearchCard__StyledMessage",
  componentId: "sc-gk8n5a-10"
})(["color:#4d4d4d;font-size:14px;overflow:hidden;height:100%;text-overflow:ellipsis;white-space:nowrap;flex-grow:1;"]);
var StyledType = _styledComponents["default"].div.withConfig({
  displayName: "CommunicationSearchCard__StyledType",
  componentId: "sc-gk8n5a-11"
})(["margin-left:11px;max-width:200px;"]);
CommunicationSearchCard.Types = _constants.CLIENT_LOG_TYPES;
var _default = exports["default"] = CommunicationSearchCard;